import Icon from 'vue-awesome/components/Icon'

Icon.register({
  watch_later_rounded: {
    paths: [
      {
        d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm3.55 13.8l-4.08-2.51c-.3-.18-.48-.5-.48-.85V7.75a.77.77 0 01.76-.75c.41 0 .75.34.75.75v4.45l3.84 2.31c.36.22.48.69.26 1.05-.22.35-.69.46-1.05.24z'
      }
    ],
    width: '24',
    height: '24'
  }
})
